import { uid } from "uid";

export default function generateUniqueId() {
  return uid();
}
